'use strict';
function get_elem($translate) {
    var elements = [
        {
            type: 'docs',
            label: $translate.instant('DASHBOARD.DASH_BUILDER.ELEMENTS.DOCS'),
            templateData: {
                placeholder: null
            },
            validation: {
                limit: 1, //0 is no limit
                required: false,
            }
        },
        {
            type: 'video',
            label: $translate.instant('DASHBOARD.DASH_BUILDER.ELEMENTS.VIDEOS'),
            templateData: {
                placeholder: null,
                bodyCam: false
            },
            validation: {
                limit: 1, //0 is no limit
                required: false,
            }
        },
        {
            type: 'photo',
            label: $translate.instant('DASHBOARD.DASH_BUILDER.ELEMENTS.PHOTOS'),
            templateData: {
                placeholder: null
            },
            validation: {
                limit: 0, //0 is no limit
                required: false,
            }
        }, {
            type: 'sign',
            label: $translate.instant('DASHBOARD.DASH_BUILDER.ELEMENTS.SIGN'),
            templateData: {
                placeholder: null,
                allowSignProfile: false
            },
            validation: {
                required: false,
            }
        }, {
            type: 'title',
            label: $translate.instant('DASHBOARD.DASH_BUILDER.ELEMENTS.TITLE'),
            templateData: {
                href: null,
                hidden: false,
                useAsTitle: false
            }
        }, {
            type: 'autonumeric',
            label: $translate.instant('DASHBOARD.DASH_BUILDER.ELEMENTS.AUTONUMERIC'),
            templateData: {
                hidden: true,
                useAsTitle: false,
                lastValue: 0
            }
        }, {
            type: 'group',
            label: $translate.instant('DASHBOARD.DASH_BUILDER.ELEMENTS.GROUP'),
            templateData: {
                placeholder: null
            },
            requires: [],
            nodes: []
        }, {
            type: 'simplelist',
            label: $translate.instant('DASHBOARD.DASH_BUILDER.ELEMENTS.SIMPLELIST'),
            templateData: {
                placeholder: null,
                fields: []
            },
            requires: [],
            nodes: []
        }, {
            type: 'text',
            label: $translate.instant('DASHBOARD.DASH_BUILDER.ELEMENTS.TEXT'),
            templateData: {
                placeholder: null,
                useAsTitle: false,
                rowSpan: 1
            },
            validation: {
                maxLength: 0,
                minLength: 0,
                required: false,
            }
        }, {
            type: 'sendemail',
            label: $translate.instant('DASHBOARD.DASH_BUILDER.ELEMENTS.SENDEMAIL'),
            templateData: {
                placeholder: null,
                useAsTitle: false,
                rowSpan: 1,
                asSelect: false,
                options: [],
                optionsAsButtons: false,
                onlyOne: false
            },
            validation: {
                required: false,
            }
        }, {
            type: 'select',
            label: $translate.instant('DASHBOARD.DASH_BUILDER.ELEMENTS.SELECT'),
            templateData: {
                placeholder: null,
                options: [],
                useAsTitle: false,
                optionsAsButtons: false
            },
            validation: {
                required: false,
            }
        }, {
            type: 'validate',
            label: $translate.instant('DASHBOARD.DASH_BUILDER.ELEMENTS.VALIDATE'),
            templateData: {
                placeholder: null
            },
            validation: {
                required: false,
            }
        }, {
            type: 'populate',
            label: $translate.instant('DASHBOARD.DASH_BUILDER.ELEMENTS.POPULATE'),
            templateData: {
                placeholder: null
            },
            validation: {
                required: false,
            }
        }, {
            type: 'checkbox',
            label: $translate.instant('DASHBOARD.DASH_BUILDER.ELEMENTS.CHECKBOX'),
            templateData: {
                placeholder: null
            },
            validation: {
                required: false,
            }
        }, {
            type: 'multiple',
            label: $translate.instant('DASHBOARD.DASH_BUILDER.ELEMENTS.MULTIPLE'),
            templateData: {
                placeholder: null,
                options: [],
                noModal: false,
                optionsAsButtons: false,
                onlyOne: false
            },
            validation: {
                required: false,
            }
        }, {
            type: 'geo',
            label: $translate.instant('DASHBOARD.DASH_BUILDER.ELEMENTS.GEO'),
            templateData: {
                placeholder: null
            },
            validation: {
                required: false,
            }
        }, {
            type: 'timestamp',
            label: $translate.instant('DASHBOARD.DASH_BUILDER.ELEMENTS.TIMESTAMP'),
            templateData: {
                placeholder: null,
                useAsTitle: false
            },
            validation: {
                required: false,
            }
        }, {
            type: 'date',
            label: $translate.instant('DASHBOARD.DASH_BUILDER.ELEMENTS.DATE'),
            templateData: {
                placeholder: null,
                useAsTitle: false
            },
            validation: {
                allowPrevious: true,
                allowFuture: true,
                required: false,
                maxPrevious: 0,
                maxFuture: 0
            }
        }, {
            type: 'time',
            label: $translate.instant('DASHBOARD.DASH_BUILDER.ELEMENTS.TIME'),
            templateData: {
                placeholder: null
            },
            validation: {
                allowPrevious: true,
                allowFuture: true,
                required: false,
                maxPrevious: 0,
                maxFuture: 0
            }
        }, {
            type: 'number',
            label: $translate.instant('DASHBOARD.DASH_BUILDER.ELEMENTS.NUMBER'),
            templateData: {
                placeholder: null,
                useAsTitle: false,
                btnCounter: false,
                valuesCounter: "1"
            },
            validation: {}
        }, {
            type: 'qr',
            label: $translate.instant('DASHBOARD.DASH_BUILDER.ELEMENTS.QR'),
            templateData: {
                placeholder: null,
                useAsTitle: false
            },
            validation: {}
        }, {
            type: 'formula',
            label: $translate.instant('DASHBOARD.DASH_BUILDER.ELEMENTS.FORMULA'),
            templateData: {
                placeholder: null,
                hidden: false,
                useAsTitle: true,
                formula: {
                    formula: null,
                    variables: [],
                    totalLabel: null
                },
                formulaAdvanced: {
                    formula: null,
                    variables: [],
                    totalLabel: null
                }
            },
            validation: {}
        }, {
            type: 'duration',
            label: $translate.instant('DASHBOARD.DASH_BUILDER.ELEMENTS.DURATION'),
            templateData: {
                placeholder: null
            },
            validation: {}
        }];


    elements.sort(function (a, b) {
        if (a.label < b.label) {
            return -1;
        }
        if (a.label > b.label) {
            return 1;
        }
        // names must be equal
        return 0;
    });
    return elements
}
module.exports = get_elem;
